import type { ActionFunctionArgs } from '~/types/route-args';

import { passkeyLoginOptionsAction } from '~/modules/user/passkey/passkey.server';

export const PASSKEY_LOGIN_OPTIONS_API_ROUTE =
    '/remix-api/user/passkey-login-options';

export const action = (args: ActionFunctionArgs) =>
    passkeyLoginOptionsAction(args);

export type PasskeyLoginOptionsAction =
    | { ok: true; optionsJSON: string }
    | { ok: false; message: string };
